import { createStore, ModuleTree } from "vuex";
import use from "./utils";
// modules
const files = require.context("./modules", false, /\/[a-z].*\.[jt]s$/);
const modules = files
  .keys()
  .reduce((all: ModuleTree<any>, fileName: string) => {
    const { default: module } = files(fileName);
    if (module) {
      const key = (fileName.match(/([^./]+).[jt]s/) || "")[1];
      all[key] = module;
    }
    return all;
  }, {});
console.log("modules", modules);
const root = {
  state: {},
  getters: {
    token: (state: any): string | null => {
      return state.user?.token ?? "";
    },
    userInfo: (state: any): string | null => {
      return state.user?.userInfo ?? "";
    },
    isLogin: (state: any): boolean => {
      return !!state.user?.token;
    },
    curShop: (state: any): string | null => {
      return state.user?.curShop ?? "";
    },
  },
  mutations: {},
  actions: {},
  modules: modules,
  plugins: [],
};

export const useSite = () => "ja";
export const isEN = () => false;
export const useUser: any = () => ({});

use(root).bindMutation().persistState();

const store = createStore(root);
export default store;
